"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UploadItem = _interopRequireDefault(require("../UploadItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Container = _styledComponents.default.div`
  width: 100%;
  height: 100%;
`;

const UploadItemCollection = ({
  uploads,
  removeHandler
}) => {
  return /*#__PURE__*/_react.default.createElement(Container, null, uploads.map(upload => /*#__PURE__*/_react.default.createElement(_UploadItem.default, {
    key: upload.uid,
    upload: upload,
    removeHandler: removeHandler
  })));
};

var _default = UploadItemCollection;
exports.default = _default;